export const serviceTableData = [
  {
    service: '법률 문제\n긴급상담',
    details: [
      '환자 클레임·합의 요구',
      '직원 인사노무 문제',
      '보건소 현장조사 대응',
      '전화 상담 및 합의 절차 지원',
    ],
    frequency: '횟수 제한 없음',
    note: null,
  },
  {
    service: '의료사고\n전문 상담',
    details: [
      '의료과실 여부 사전 판단 (의료감정)',
      '확정 손해배상액·합의금 산정',
      '협상대행 — 전화·이메일·공문',
      '보건소·보건복지부 소통 대행',
    ],
    frequency: '기본 월 1회',
    note: '초과 시 본인부담금 추가',
  },
  {
    service: '내용증명·\n경고장 발송',
    details: [
      '경고장 작성 및 법무법인 명의 발송',
      '악성 민원·허위 사실 유포 대응',
      '필요 시 로펌 통해 제공 가능',
    ],
    frequency: '건별 제공',
    note: null,
  },
  {
    service: '인사노무\n전문 서비스',
    details: [
      '직원 인사노무 문제 긴급 대응',
      '징계·해고 절차 진행 대응',
      '인사위원회·징계위원회 구성 지원',
    ],
    frequency: '포함',
    note: null,
  },
];

export const contractData = [
  {
    variant: 'navy',
    eye: 'Group Contract',
    title: '의료인 단체 · 학회 ·\n네트워크 의원 단체계약',
    desc: '소속 회원 또는 가맹 의원 전체를 대상으로 하는 단체 계약입니다. 협회·학회·네트워크 운영사가 일괄 계약하고, 회원들은 medilawyer 서비스를 즉시 이용할 수 있습니다.',
    items: [
      { strong: '회원 단체 할인 적용', rest: ' — 개별 계약 대비 우대 요금으로 제공' },
      { strong: '단체 전용 연락 채널', rest: ' 별도 개설 및 우선 응대' },
      { strong: '회원 대상 법률 세미나·교육', rest: ' 정기 제공 가능' },
      { strong: null, rest: '의사회·치과의사회·한의사회·전문학회·네트워크 의원 모두 가능' },
      { strong: null, rest: '계약 조건은 단체 규모에 따라 맞춤 협의' },
    ],
    btnLabel: '단체계약 문의하기',
    btnTab: 'group',
  },
  {
    variant: 'teal',
    eye: 'Single Case',
    title: '단건 계약 —\n사건 하나부터 시작하세요',
    desc: '분쟁·민원이 발생한 그 순간, 필요한 서비스만 즉시 이용하세요. 월정액 없이 사건별로 전문 법률 지원을 받을 수 있습니다. 단건 이용 후 정기자문 계약으로 전환도 가능합니다.',
    items: [
      { strong: '즉시 개시', rest: ' — 계약 체결 후 24시간 이내 전담 변호사 배정' },
      { strong: '사건별 맞춤 대응', rest: ' — 진료비 분쟁·악성 리뷰·환자 민원 전부 가능' },
      { strong: '투명한 비용', rest: ' — 사전 견적 확인 후 진행, 숨은 비용 없음' },
      { strong: '의사·치과의사 출신 변호사', rest: '가 직접 담당' },
      { strong: '단건 → 정기자문 전환', rest: ' 가능 (오킴스 의료팀과 정식 계약)' },
    ],
    btnLabel: '단건계약 신청하기',
    btnTab: 'advisory',
  },
];
